define('pages/rent-details',["exports", "common", "controls/calendar2", "controls/switcher", "odometer", "views/details", "bootstrap/tooltip"], function (_exports, _common, _calendar, _switcher, _odometer, _details, _tooltip) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _calendar = _interopRequireDefault(_calendar);
  _switcher = _interopRequireDefault(_switcher);
  _odometer = _interopRequireDefault(_odometer);
  _details = _interopRequireDefault(_details);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  var ApartmentCalendar = _calendar.default.extend({
    initialize(options) {
      _calendar.default.prototype.initialize.apply(this, arguments);
      this.apartmentID = options.apartmentID;
    },
    _load(month, count) {
      return (0, _common.getJSON)(`/apartments/${this.apartmentID}/calendar-2/${month}?count=${count}&src=2`);
    }
  });
  var _default = _exports.default = _details.default.extend({
    events: {
      'click .rental-bar .rental-bar__btn--primary': _common.slideTo,
      'click .rental-book .rental-book__btn-book': '_book',
      'click .rental-calendar .calendar-nav__icon-next': '_nextCalendarMonth',
      'click .rental-calendar .calendar-nav__icon-prev': '_prevCalendarMonth',
      'click .rental-cover .rental-cover__arrow': _common.slideTo,
      'click .rental-cover .rental-cover__book-btn': _common.slideTo
    },
    initialize() {
      _details.default.prototype.initialize.apply(this, arguments);
      {
        var calendarSection = this.el.querySelector('.rental-calendar');
        this.calendarPrevMonth = calendarSection.querySelector('button.calendar-nav__icon-prev');
        this.calendar = calendarSection.querySelector('.c-datepicker__calendar');
        this.calendarMonth = 0;
      }
      {
        var bookSection = this.el.querySelector('.rental-book');
        var bookPriceValue = bookSection.querySelector('.rental-book-price__number');
        var priceValue = Number(bookPriceValue.textContent);
        if (!Number.isNaN(priceValue)) {
          this.bookOdometer = new _odometer.default({
            el: bookPriceValue,
            format: 'd',
            duration: 500,
            value: bookPriceValue.textContent
          });
        }
        var bookDate = this.bookDate = bookSection.querySelector('.js-date');
        this.bookDateCalendar = new ApartmentCalendar({
          el: bookDate.querySelector('.c-datepicker'),
          cssClass: 'c-datepicker--dropdown',
          model: this.state,
          apartmentID: this.modelID
        });
        this.listenTo(this.bookDateCalendar, 'done', () => {
          bookDate.querySelector('#book-calendar').hidePopover();
        });
        this.bookDateCalendar.init();
        var bookGuests = bookSection.querySelector('.js-guests');
        this.bookGuests = new _switcher.default(bookGuests.querySelector('.rental-book__guests'), {
          model: this.state,
          prop: 'guests',
          onChange() {
            bookGuests.querySelector('#book-guests').hidePopover();
          }
        });
      }
      this.listenTo(this.state, 'change:currency change:date change:guests', async () => {
        var _price$error, _price$warning;
        this._updateContactLink();
        var query = this.state.getQuery();
        history.replaceState({}, '', `${location.pathname}?${query}`);
        var price = await (0, _common.getJSON)(`/apartments/${this.modelID}/price?${query}`);
        this.state.set({
          _price: price.amount,
          _price_prefix: price.prefix,
          _price_suffix: price.suffix,
          _avg: price.avg,
          error: (_price$error = price.error) !== null && _price$error !== void 0 ? _price$error : null,
          warning: (_price$warning = price.warning) !== null && _price$warning !== void 0 ? _price$warning : null
        });
      });
      this.listenTo(this.state, 'change:currency', async () => {
        this._loadCalendar();
        var url = new URL(location.href);
        url.searchParams.set('rates', '1');
        var data = await (0, _common.getJSON)(url);
        this.el.querySelector('.rental-grid__col-rates').innerHTML = data.rates;
      });
      this._updateContactLink();
    },
    async _loadCalendar() {
      var data = await (0, _common.getJSON)(`/apartments/${this.modelID}/calendar-2/${this.calendarMonth}?currency=${GA.currency()}&count=3&src=3`);
      this.calendar.textContent = '';
      this.calendar.insertAdjacentHTML('beforeend', data.calendar);
      this.calendarPrevMonth.disabled = this.calendarMonth === 0;
    },
    _prevCalendarMonth() {
      this.calendarMonth--;
      this._loadCalendar();
    },
    _nextCalendarMonth() {
      this.calendarMonth++;
      this._loadCalendar();
    },
    _updateContactLink() {
      var contactLink = this.el.querySelector('.rental-book__message-btn');
      var url = new URL(contactLink.href);
      contactLink.href = `${url.pathname}?${this.state.getQuery()}`;
    },
    _book() {
      var date = this.state.get('date');
      if (date) {
        location.href = `/apartments/${this.modelID}/book?${this.state.getQuery()}`;
      } else {
        this.bookDate.querySelector('#book-calendar').showPopover();
      }
    }
  });
});//# sourceMappingURL=rent-details.js.map
;
